import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    try {
      window.parent.scrollTo(0, 0);
    } catch (e) {
      // cross-origin parent, ignore
    }
  }, [pathname]);

  return null;
}
